import React from "react";
import clsx from "clsx";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost" | "outline";
  size?: "sm" | "md" | "lg";
};

export default function Button({ variant = "primary", size = "md", className, style, ...props }: Props) {
  const variantClass = {
    primary: "btn--primary",
    ghost:   "btn--ghost",
    outline: "btn--ghost",
  }[variant];

  const sizeStyle = size === "lg" ? { padding: "18px 28px" } : undefined;

  return (
    <button
      className={clsx(
        "btn",
        variantClass,
        size === "sm" && "btn--sm",
        "focus:outline-none focus:ring-2 focus:ring-[var(--c-teal-weak)]",
        className
      )}
      style={{ ...sizeStyle, ...style }}
      {...props}
    />
  );
}
